export default {
  GET_LIST: '/manage/video/findList',
  CHANGE_STATUS: '/manage/video/enableOperate',
  DEL: '/manage/video/delete',
  FIND: '/manage/video/find',
  UPLOAD_FILE: '/auth/public/upload/aliFile',
  SAVE_OR_UPDATE: '/manage/video/saveOrUpdate',
  UPDATE_VIDEO: '/auth/public/update/aliVideo',
  CREATE_URL: '/auth/public/get/aliVideo/voucher',
  REFRESH_URL: '/auth/public/refresh/aliVideo/voucher'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/newVideoManagement.js